import React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

type Props = {
    children: React.ReactNode;
    width?: number | string;
    sx?: SxProps<Theme>;
};

const AppModalBox = ({ children, width = 400, sx }: Props) => {
    return (
        <Box
            sx={(theme) => ({
                p: 4,
                mx: "auto",
                width,
                bgcolor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.divider}`,
                outline: "none",
                ...((typeof sx === "function" ? sx(theme) : sx) as any),
            })}
        >
            {children}
        </Box>
    );
};

export default AppModalBox;
